import { render } from "./processInformation.vue?vue&type=template&id=d5d953e0&scoped=true&ts=true"
import script from "./processInformation.vue?vue&type=script&lang=ts"
export * from "./processInformation.vue?vue&type=script&lang=ts"

import "./processInformation.vue?vue&type=style&index=0&id=d5d953e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5d953e0"]])

export default __exports__